import script from "./GaugesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./GaugesTable.vue?vue&type=script&setup=true&lang=ts"

import "./GaugesTable.vue?vue&type=style&index=0&id=664122b0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664122b0"]])

export default __exports__